import { useEffect, useState } from 'react';

import { UseState } from '../types';

/**
 * Czy aplikacja przeszła już podłączanie (hydrację).
 *
 * Komponenty, które wybierają wariant układu na podstawie szerokości ekranu, nie mogą
 * zrobić tego przy PIERWSZYM renderowaniu w przeglądarce: serwer szerokości nie zna
 * i rysuje wariant szeroki, więc różne drzewo po obu stronach kończy się wyrzuceniem
 * poddrzewa przez Reacta. Muszą więc poczekać na zamontowanie.
 *
 * Ale czekać ma sens WYŁĄCZNIE przy podłączaniu aplikacji. Komponent montowany później,
 * przy przejściu wewnątrz aplikacji, nie ma się z czym uzgadniać — żadnego HTML-a
 * z serwera dla niego nie ma — a odłożenie decyzji dawałoby mu jedną klatkę w układzie
 * szerokim i widoczny przeskok. Dlatego znacznik jest w module: pierwszy komponent po
 * podłączeniu ustawia go raz, a każdy kolejny startuje już z gotową odpowiedzią.
 *
 * Na serwerze efekty się nie wykonują, więc znacznik zostaje fałszywy — i dobrze,
 * renderowanie serwerowe ma zawsze dawać wariant szeroki.
 */
let podlaczanieZakonczone: boolean = false;

/**
 * Zgłasza, że aplikacja skończyła podłączanie. Wywołuje to `index.tsx` w wywołaniu
 * zwrotnym `ReactDOM.hydrate`. Bez tego znacznik ustawiałby dopiero PIERWSZY komponent
 * korzystający z haka — a jeśli strona wejścia takiego nie ma, komponent zamontowany
 * później i tak dostałby jedną klatkę w wariancie szerokim.
 */
export const markHydrationComplete: () => void = (): void => {
  podlaczanieZakonczone = true;
};

export const useAfterHydration: () => boolean = (): boolean => {
  const [zakonczone, setZakonczone]: UseState<boolean> = useState<boolean>(podlaczanieZakonczone);

  useEffect((): void => {
    podlaczanieZakonczone = true;
    setZakonczone(true);
  }, []);

  return zakonczone;
};
